/*
 * Copyright The OpenTelemetry Authors
 * SPDX-License-Identifier: Apache-2.0
 */

export { convertLegacyOtlpGrpcOptions } from './configuration/convert-legacy-otlp-grpc-options';
export { createOtlpGrpcExportDelegate } from './otlp-grpc-export-delegate';
export {
  createEmptyMetadata,
  createInsecureCredentials,
  createSslCredentials,
} from './grpc-exporter-transport';
export type { OTLPGRPCExporterConfigNode } from './types';
